var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#796429;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:none;stroke:#007E19;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{display:none;fill:none;stroke:#007E19;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.2,23.5v-15h8.1 M29.3,16h-6.9 M14.8,10.7c-1.2-1.2-2.8-2-4.6-2.2C8.5,8.3,6.8,8.8,5.3,9.7 c-1.4,1-2.5,2.4-3,4.1c-0.5,1.7-0.4,3.5,0.2,5.1c0.7,1.6,1.9,2.9,3.4,3.8c1.5,0.8,3.3,1.1,5,0.7c1.7-0.3,3.2-1.3,4.3-2.6 c1.1-1.3,1.7-3,1.7-4.8h-5.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,23.5h-8.1V8.5h8.1 M17.2,8.8L10,23.5H9.9L2.8,8.8 M28,16h-6.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.2,8.8L16,23.5H16L8.8,8.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/Vegan.c15632656a2b0ece9ef670043faa4758.svg";
export { ForwardRef as ReactComponent };